<div class="container-fluid mt-2 px-3" style="font-size: 0.88rem;">
  
  <div class="d-flex justify-content-between align-items-center mb-2 border-bottom pb-1">
    <h2 class="h5 m-0 fw-bold text-dark">Crear Recepción Vehicular</h2>
    <span class="badge bg-success">Nueva Recepción</span>
  </div>

  <form [formGroup]="ordenForm" (ngSubmit)="guardarOrden()">

    <!-- ========================================================================= -->
    <!-- SECCIÓN A: CABECERO OPERATIVO (DATOS DE CONTROL)                          -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm bg-light">
      <div class="card-body p-2">
        
        <div class="row g-2 mb-2">
          <div class="col-md-3">
            <div class="form-floating">
              <input type="text" class="form-control" id="folio" formControlName="folio" placeholder="REC-00000">
              <label for="folio" class="fw-bold">Folio de Recepción</label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-floating">
              <input type="datetime-local" class="form-control" id="fecha_entrada" formControlName="fecha_entrada">
              <label for="fecha_entrada" class="fw-bold">Fecha Entrada</label>
            </div>
          </div>

          <!-- SUB-GROUP: CLIENTE CORPORATIVO (Mapeo directo al AN8) -->
          <div class="col-md-4" formGroupName="customer">
            <div class="form-floating">
              <select #selectCliente class="form-select" id="selectClienteName" (change)="onClienteSeleccionado($event)"
                      [ngClass]="{'is-invalid': ordenForm.get('customer.an8')?.touched && ordenForm.get('customer.an8')?.invalid}">
                <option value="">-- Elige Cliente --</option>
                <!-- Renderiza el AN8 numérico de 8 dígitos como el valor definitivo de la opción -->
                <option *ngFor="let cliente of clientes" [value]="cliente.an8">
                  {{ cliente.name }} (AN8: {{ cliente.an8 }})
                </option>
              </select>
              <label for="selectClienteName" class="text-primary">Cliente Propietario *</label>
              <div class="invalid-feedback">Debe asociar obligatoriamente un cliente.</div>
            </div>
          </div>

          <div class="col-md-2" formGroupName="customer">
            <div class="form-floating">
              <input type="number" class="form-control bg-white text-secondary" id="id_cliente" formControlName="an8" readonly>
              <label for="id_cliente">AN8 Cliente</label>
            </div>
          </div>
        </div>

        <div class="row g-2 mb-1">
          <!-- SUB-GROUP: UNIDAD VEHICULAR (Filtrado relacional por AN8) -->
          <div class="col-md-4" formGroupName="unidad">
            <div class="form-floating">
              <select #selectVehiculo class="form-select" id="selectVehiculoDesc"
                      [disabled]="unidades.length === 0" 
                      (change)="onVehiculoSeleccionado($event)"
                      [ngClass]="{'is-invalid': ordenForm.get('unidad.id')?.touched && ordenForm.get('unidad.id')?.invalid}">
                <option value="">-- Elige Submarca - Placas --</option>
                <option *ngFor="let unidad of unidades" [value]="unidad.id">
                  {{ unidad.descripcion }}
                </option>
              </select>
              <label for="selectVehiculoDesc" class="text-primary">Vehículo Asociado *</label>
              <div class="invalid-feedback">Selección obligatoria del vehículo.</div>
            </div>
          </div>

          <div class="col-md-2" formGroupName="unidad">
            <div class="form-floating">
              <input type="number" class="form-control bg-white text-secondary" id="id_vehiculo" formControlName="id" readonly>
              <label for="id_vehiculo">ID Vehículo</label>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-floating">
              <input type="number" class="form-control" id="kilometraje" formControlName="kilometraje" placeholder="0"
                     [ngClass]="{'is-invalid': ordenForm.get('kilometraje')?.touched && ordenForm.get('kilometraje')?.invalid}">
              <label for="kilometraje">Kilometraje Actual *</label>
              <div class="invalid-feedback">El kilometraje es requerido y no puede ser negativo.</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-floating">
              <select class="form-select" id="nivelCombustible" formControlName="nivelCombustible"
                      [ngClass]="{'is-invalid': ordenForm.get('nivelCombustible')?.touched && ordenForm.get('nivelCombustible')?.invalid}">
                <option value="">-- Seleccione --</option>
                <option value="Vacio">Vacio</option>
                <option value="1/4">1/4</option>
                <option value="1/2">1/2</option>
                <option value="3/4">3/4</option>
                <option value="Lleno">Lleno</option>
              </select>  
              <label for="nivelCombustible">Combustible *</label>
              <div class="invalid-feedback">El nivel de combustible es obligatorio.</div>
            </div>
          </div>

		      <!-- Selector de Asesor Sincronizado al Libro de Direcciones (F0101) -->
          <div class="col-md-2">
            <div class="form-floating">
              <select #selectAsesor class="form-select" id="id_asesor" formControlName="id_asesor"
                      [ngClass]="{'is-invalid': ordenForm.get('id_asesor')?.touched && ordenForm.get('id_asesor')?.invalid}">
                <option value="">-- Seleccione Asesor --</option>
                <!-- 💡 CORREGIDO: Cambiado de asesor.id/name a asesor.an8/nombre para hacer match con tu UserLookupDTO -->
                <option *ngFor="let asesor of asesores" [value]="asesor.an8">
                  {{ asesor.username }} (AN8: {{ asesor.an8 }})
                </option>
              </select>
              <label for="id_asesor">Asesor de Servicio *</label>
              <div class="invalid-feedback">Asesor obligatorio.</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- OBSERVACIONES GENERALES Y ADJUNTOS -->
    <div class="row g-2 mb-2">
      <div class="col-md-8">
        <div class="form-floating">
          <textarea class="form-control" id="observaciones_generales" formControlName="observaciones_generales" 
                    rows="2" style="height: 58px; text-transform: uppercase;" 
                    (input)="ordenForm.get('observaciones_generales')?.setValue(ordenForm.get('observaciones_generales')?.value?.toUpperCase(), {emitEvent: false})"
                    placeholder="Notas..."></textarea>
          <label for="observaciones_generales">Observaciones Generales de Recepción</label>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-floating">
          <input type="file" class="form-control" id="fotosInput" multiple (change)="onFilesSelected($event)" accept="image/*">
          <label for="fotosInput" class="fw-bold text-success">📷 Adjuntar Evidencia (Múltiples Fotos)</label>
        </div>
      </div>
    </div>



	<!-- 🌟 SECCIÓN: MODALIDAD DE COSTOS DE REVISIÓN CON COSTO ESPECÍFICO -->
    <div class="card mb-2 border-0 shadow-sm bg-white">
      <div class="card-body p-2 shadow-sm border rounded">
        <div class="row align-items-center g-2">
          
          <!-- Título -->
          <div class="col-12 col-md-3 col-lg-3">
            <div class="d-flex align-items-center gap-2">
              <span class="fs-5">💰</span>
              <div>
                <div class="fw-bold text-dark" style="font-size: 0.85rem; line-height: 1.1;">COSTOS DE REVISIÓN</div>
                <div class="text-muted small" style="font-size: 0.72rem;">Selección de Modalidad obligatoria</div>
              </div>
            </div>
          </div>
          
          <!-- Opciones de Radio Buttons -->
          <div class="col-12 col-md-9 col-lg-9 d-flex flex-wrap align-items-center gap-2">
            <div class="d-flex flex-wrap gap-2">
              
              <!-- Gratis -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoGratis" value="GRATIS" formControlName="modalidadCosto">
              <label class="btn btn-costo-gratis btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoGratis">
                <span class="radio-dot"></span> Diagnóstico Gratis (0)
              </label>

              <!-- Fijo -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoFijo" value="FIJO" formControlName="modalidadCosto">
              <label class="btn btn-costo-fijo btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoFijo">
                <span class="radio-dot"></span> Costo Fijo
              </label>

              <!-- Variable -->
              <div *ngIf="tipoTallerActivo !== 'LAMINADO'" class="d-inline-block">
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoVariable" value="VARIABLE" formControlName="modalidadCosto">
              <label class="btn btn-costo-variable btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoVariable">
                <span class="radio-dot"></span> Costo Variable
              </label>
              </div>

              <!-- 🌟 NUEVO: Costo Específico -->
              <input type="radio" class="btn-check" name="modalidadCosto" id="costoEspecifico" value="ESPECIFICO" formControlName="modalidadCosto">
              <label class="btn btn-costo-especifico btn-sm px-3 fw-bold d-flex align-items-center gap-1 shadow-sm" for="costoEspecifico">
                <span class="radio-dot"></span> Costo Específico
              </label>
              
            </div>

            <!-- INPUT NUMÉRICO CONDICIONAL CORREGIDO PARA DECIMALES -->
            <div *ngIf="ordenForm.get('modalidadCosto')?.value === 'ESPECIFICO'" class="animate__animated animate__fadeIn" style="width: 180px;">
              <div class="input-group input-group-sm has-validation">
                <span class="input-group-text bg-danger text-white fw-bold">$</span>
                <input type="number" 
                      class="form-control form-control-sm text-end fw-bold text-danger" 
                      [ngClass]="{'is-invalid': ordenForm.get('costoMonto')?.touched && (ordenForm.get('costoMonto')?.invalid || ordenForm.get('costoMonto')?.value <= 0)}"
                      formControlName="costoMonto" 
                      placeholder="0.00" 
                      min="0.01"
                      step="0.01"> <!-- 🌟 Permite incrementos decimales precisos -->
                <div class="invalid-feedback fw-bold" style="font-size: 0.7rem;">Debe ser mayor a 0</div>
              </div>
            </div>

          </div>

        </div>
      </div>
    </div>



    <!-- ========================================================================= -->
    <!-- SECCIÓN B: TRABAJOS SOLICITADOS / SÍNTOMAS DEL CLIENTE                   -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        <div class="fw-bold text-dark mb-1" style="font-size: 0.85rem;">🛠️ MOTIVOS DE INGRESO Y FALLAS REPORTADAS</div>
        
        <div formArrayName="sintomas">
          <div *ngFor="let sintoma of sintomas.controls; let j = index" [formGroupName]="j" class="input-group input-group-sm mb-1">
            <span class="input-group-text bg-light fw-bold text-secondary" style="width: 75px;">Falla #{{ j + 1 }}</span>
            <input type="text" class="form-control" id="descripcion_falla" formControlName="descripcion_falla"                   
                  style="text-transform: uppercase;"
                  (input)="sintoma.get('descripcion_falla')?.setValue(sintoma.get('descripcion_falla')?.value?.toUpperCase(), {emitEvent: false})"              
                  placeholder="Ej: Ruido metálico en la rueda delantera izquierda al frenar..."
                  [ngClass]="{'is-invalid': sintoma.get('descripcion_falla')?.touched && sintoma.get('descripcion_falla')?.invalid}">
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="removerSintoma(j)" [disabled]="sintomas.length === 1">
              Eliminar
            </button>
          </div>
        </div>
        <button type="button" class="btn btn-xs btn-outline-primary mt-1 px-3" style="font-size: 0.75rem;" (click)="agregarSintoma()">
          ➕ Añadir otra falla reportada
        </button>
      </div>
    </div>

    <!-- ========================================================================= -->
    <!-- SECCIÓN C: CROQUIS INTERACTIVO DE DAÑOS ESTÉTICOS                         -->
    <!-- ========================================================================= -->
    <div class="row mb-4 justify-content-center">
      <div class="col-md-10 text-center">
        <h3 class="mt-2">🗺️ Inspección Visual de Carrocería (Mapa de Daños)</h3>
        <p class="text-muted small">Haz clic sobre cualquier parte del auto para registrar un daño.</p>
        
        <!-- 🌟 NUEVO: Selector manual de asistencia técnica (Por si la UDC viene vacía o quieren cambiarlo) -->
        <div class="mb-2 d-inline-block text-start">
          <label class="form-label small fw-bold text-muted m-0 me-2">Cambiar silueta manualmente:</label>
          <select class="form-select form-select-sm d-inline-block w-auto" formControlName="tipoSilueta" (change)="onCambioManualCarroceria($event)">
            <option value="Sedán">🚗 Sedán (Default)</option>
            <option value="SUV">🚙 SUV / Crossover</option>
            <option value="Pickup">🛻 Pickup / Batea</option>
            <option value="Camión">🚚 Camión de Carga</option>
            <option value="Autobús">🚌 Autobús / Pasajeros</option>
          </select>          
        </div>

        <div class="croquis-canvas-container" (click)="onCroquisClick($event)">
          
          <!-- Imagen base del vehículo -->
          <img [src]="currentVehicleSvg" alt="Croquis Vehículo" class="croquis-vehicle-img" />

          <!-- Renderizado de los pines en porcentaje -->
          <div 
            *ngFor="let pin of pinesCarroceria" 
            class="croquis-pin" 
            [ngClass]="pin.tipoDano.toLowerCase()"
            [style.left.%]="pin.xPercentage"
            [style.top.%]="pin.yPercentage"
            (click)="$event.stopPropagation(); removerPinCroquis(pin)"
            [title]="pin.tipoDano + ': ' + pin.descripcion">
          </div>

          <!-- 🌟 CAJA DEL MENÚ CON LA SINTAXIS MÁS ESTABLE DE ANGULAR -->
          <div *ngIf="mostrarMenuFlotante" 
              class="menu-flotante-dano"
              [style.left]="posicionPantallaMenu.left + 'px'"
              [style.top]="posicionPantallaMenu.top + 'px'"
              (click)="$event.stopPropagation()">
            
            <div class="menu-header">📋 Registrar Daño</div>
            
            <input type="text" [(ngModel)]="comentarioTemporal" [ngModelOptions]="{standalone: true}" 
                  placeholder="Nota rápida..." class="form-control form-control-sm my-1">

            <div class="d-grid gap-1">
              <button type="button" class="btn btn-sm text-white btn-orange" (click)="confirmarDano('RAYON')">🟠 Rayón / Arañazo</button>
              <button type="button" class="btn btn-sm text-white btn-red" (click)="confirmarDano('GOLPE')">🔴 Golpe / Abolladura</button>
              <button type="button" class="btn btn-sm text-white btn-purple" (click)="confirmarDano('ROTURA')">🟣 Rotura / Grieta</button>
              <button type="button" class="btn btn-sm text-white btn-brown" (click)="confirmarDano('OXIDO')">🟤 Óxido / Corrosión</button>
              <button type="button" class="btn btn-sm text-white btn-yellow" (click)="confirmarDano('PICADURA')">🟡 Picadura / Piedra</button>
              <button type="button" class="btn btn-sm btn-light border mt-1" (click)="cancelarDano()">Cancelar</button>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- ========================================================================= -->
    <!-- SECCIÓN D: TABLA DE INVENTARIO Y REVISIÓN DE COMPONENTES                 -->
    <!-- ========================================================================= -->
    <div class="card mb-2 border-0 shadow-sm">
      <div class="card-body p-2">
        <div class="fw-bold text-dark mb-1" style="font-size: 0.85rem;">📋 INVENTARIO DE PERTENENCIAS Y ACCESORIOS DE CONTROL</div>
        
        <div formArrayName="detalles" class="table-responsive">
          <table class="table table-sm table-bordered m-0" style="vertical-align: middle;">
            <thead class="table-light text-secondary text-center" style="font-size: 0.8rem;">
              <tr>
                <th style="width: 40px;">#</th>
                <th style="width: 45%;">Artículo / Pertenencia Evaluada</th>
                <th style="width: 150px;">Estado</th>
                <th style="width: 90px;">Cantidad</th>
                <th>Comentario Específico / Detalle Adicional</th>
                <th style="width: 75px;">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detalle of detalles.controls; let i = index" [formGroupName]="i">
                <td class="text-center bg-light font-monospace" style="font-size: 0.8rem;">{{ i + 1 }}</td>
                <td>
                  <!-- Selector Angular Material camuflado mediante las variables del CSS -->
                  <mat-form-field appearance="outline" class="w-100 selector-estilo-bootstrap">
                    <mat-select formControlName="item_nombre" placeholder="-- Seleccione un artículo --" (selectionChange)="evaluarValidacionComentario(i)">
                      <ng-container *ngFor="let grupo of productosAgrupados; let primero = first">
                        <mat-divider *ngIf="!primero"></mat-divider>
                        <mat-option [disabled]="true" class="fw-bold text-uppercase bg-light" style="font-size: 0.75rem; color: #495057;">
                          {{ grupo.categoria }}
                        </mat-option>
                        <mat-option *ngFor="let prod of grupo.opciones" [value]="prod.id">
                          {{ prod.nombre }}
                        </mat-option>
                      </ng-container>
                      <mat-divider></mat-divider>
                      <mat-option value="OTROS" class="text-primary fw-bold">OTROS (Especificar)</mat-option>
                    </mat-select>
                    <mat-error *ngIf="detalle.get('item_nombre')?.touched && detalle.get('item_nombre')?.invalid">Obligatorio</mat-error>
                  </mat-form-field>
                </td>
                <td>
                  <select class="form-select form-select-sm" formControlName="estado"
                          [ngClass]="{'is-invalid': detalle.get('estado')?.touched && detalle.get('estado')?.invalid}">
                    <option value="">-- Elige --</option>
                    <option value="Bueno">Bueno 👍</option>
                    <option value="Malo">Malo 👎</option>
                    <option value="N/A">N/A ⚪</option>
                  </select>
                </td>
                <td>
                  <input type="number" class="form-control form-control-sm text-center" formControlName="cantidad" min="1"
                         [ngClass]="{'is-invalid': detalle.get('cantidad')?.touched && detalle.get('cantidad')?.invalid}">
                </td>
                <td>
                  <input type="text" class="form-control form-control-sm" id="comentario_especifico" formControlName="comentario_especifico"                         
                        style="text-transform: uppercase;"
                        (input)="detalle.get('comentario_especifico')?.setValue(detalle.get('comentario_especifico')?.value?.toUpperCase(), {emitEvent: false})"                
                        [ngClass]="{'is-invalid': detalle.get('comentario_especifico')?.touched && detalle.get('comentario_especifico')?.invalid}"
                        placeholder="Escriba notas sobre rayaduras, faltantes, marcas...">
                  <div class="invalid-feedback" style="font-size: 0.72rem; font-weight: bold;">
                    Requerido al elegir 'Otros'.
                  </div>
                </td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-danger p-1 px-2" (click)="removerLinea(i)" [disabled]="detalles.length === 1">
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button type="button" class="btn btn-sm btn-outline-secondary mt-1 px-3" style="font-size: 0.75rem;" (click)="agregarLinea()">
          ➕ Agregar otro renglón al inventario
        </button>
      </div>
    </div>

    <!-- SECCIÓN DE DISPACHO FINAL -->
    <div class="d-flex justify-content-end gap-2 border-top pt-2 mt-2">
	    <!-- 🚀 ACTIVACIÓN DE SALIDA SEGURA EN ALTA DE RECEPCIONES -->
      <!-- Cambiamos a la etiqueta <a> con routerLink para regresar de golpe al listado general '/recepciones' -->
      <a routerLink="/recepciones" class="btn btn-sm btn-outline-secondary px-4 d-inline-flex align-items-center">
        Cancelar
      </a>
      <button type="submit" class="btn btn-sm text-white px-5 shadow-sm fw-bold" 
              [style.opacity]="ordenForm.invalid ? '0.5' : '1'" 
              style="background-color: #198754;">
        Guardar Recepción Completa
      </button>
    </div>

  </form>
</div>

<!-- 🌟 CONTENEDOR FLOTANTE DE TOASTS -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
    </div>
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>